import React, { useState } from 'react';
import NotificationAPI from '../../../../axios/notification';
import { PanelIcon } from '../../user-panel';

export default function UserNotification({ notification }) {
  const [expanded, setExpanded] = useState(false);
  const [unread, setUnread] = useState(!notification.is_read);

  const toggle = () => {
    if (unread) {
      NotificationAPI.readNotification(notification.id)
        .then(() => setUnread(false))
        .catch(() => {});
    }
    setExpanded(prevExpanded => !prevExpanded);
  };

  return (
    <div className={`hs-panel-message ${unread ? 'unread' : ''}`}>
      <button className='hs-panel-message-main' onClick={toggle} aria-expanded={expanded}>
        <span className='hs-panel-message-avatar'><PanelIcon name='bell' /></span>
        <span className='hs-panel-message-text'>
          <span className='hs-panel-message-top'>
            <span className='hs-panel-message-subject'>{notification.notification_type.label}</span>
            {unread && <span className='hs-panel-message-dot'></span>}
            <span className='hs-panel-message-date'>{new Date(notification.date_created).toLocaleString('sr-RS', { dateStyle: 'short', timeStyle: 'short' })}</span>
          </span>
        </span>
        <svg className={`hs-panel-message-chevron ${expanded ? 'open' : ''}`} width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5 6 6.5 11 1.5" stroke="#5B6779" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>
      {expanded && (
        <div className='hs-panel-message-body'>
          <div className='hs-panel-notification-text' dangerouslySetInnerHTML={{ __html: notification.body }} />
        </div>
      )}
    </div>
  );
}
